module.exports = __webpack_public_path__ + "static/media/service.11ff65fa.svg";